import { useState, useEffect } from 'react'
import { Anchor, Spinner, Card, CardBody, CardFooter, CardHeader, Text, Table, TableBody, TableHeader, TableRow, TableCell, Box, Button } from 'grommet'

import ReportNavigation from './ReportNavigation'
import BoardFilter from './BoardFilter'
import GenericGraph from './GenericGraph'

import { combinedScoresData } from '../helpers';
import { doc } from 'firebase/firestore'

const CenterBoard = ({ firestore }) => {
  const [dashData, setDashData] = useState()
  const [fDate, setFDate] = useState()
  const [showdash, setShowDash] = useState(true);

  useEffect(() => {
    let isCancelled = false

    const fetchDashboard = async () => {
      const wskirtanFilters = localStorage.getItem('__WSKIRTAN_FILTERS')
      if (wskirtanFilters && JSON.parse(wskirtanFilters)) {
        return
      }
      filterValues('', '', '', 20, '');
      // const scoresQuery = firestore.collection('hkcenters').orderBy('score', 'desc').limit(20)
      // const scoresData = await scoresQuery.get()

      // if (isCancelled) {
      //   return
      // }

      // if (!isCancelled) {
      //   setDashData(scoresData.docs)
      // }
    }

    fetchDashboard()

    // setShowDash(localStorage.getItem('showdash'));

    return () => {
      isCancelled = true
    }

  }, [])

  const filterValues = async (country, temple, hkcenter, count, fdate) => {
    let filter = {}
    if (temple) {
      filter = {name: 'temple', value: temple}
    } else if (country) {
      filter = {name: 'country', value: country}
    }

    let scoresDataDocs = [];

    if (fdate) {
      while (fdate.length > 0) {
        let fscoresQuery = firestore.collection('flydates')
          .where('datekey', 'in', fdate.slice(0, 10))
          .where('searchkey', '==', 'hkcenter');

        if (filter.name) {
          fscoresQuery = fscoresQuery.where(filter.name, '==', filter.value)
        }

        let scoresData = await fscoresQuery.orderBy('score', 'desc').get()
        scoresData.docs.filter(doc => doc.data().score).forEach(doc => scoresDataDocs.push(doc.data()));

        fdate.splice(0, 10);
      }
    } else {
      let scoresQuery = firestore.collection('hkcenters')
      if (filter.name) {
        scoresQuery = scoresQuery.where(filter.name, '==', filter.value)
      }
      let scoresData = await scoresQuery.orderBy('score', 'desc').get()
      scoresDataDocs = scoresData.docs.filter(doc => doc.data().score).map(snap => {
        return { ...snap.data(), ...{ searchval: snap.id } }
      })
    }

    const combinedData = combinedScoresData('searchval', scoresDataDocs);
    setDashData(combinedData)
  }

  return (<>
    <Card background='light-1' width='xlarge' margin={{ horizontal: 'large', vertical: 'large' }}>
      <CardHeader pad='medium' background={'light-2'}>
        <Text weight='bold' size='large'>Centers' report</Text>
        <ReportNavigation />
      </CardHeader>
      {!showdash && <CardBody pad='medium'><Text>This report is frozen till we announce the results.</Text></CardBody>}
      {showdash && <CardBody pad='medium'>
        <BoardFilter firestore={firestore} filterValues={filterValues} collection={'hkcenters'} />
        <Box overflow={{ horizontal: 'auto' }}>
          {(!dashData) && <Spinner />}
          {dashData && (dashData.length === 0) && <Text>No data</Text>}
          {dashData && (dashData.length > 0) && <Table>
            <TableHeader>
              <TableRow>
                <TableCell scope='col' border='bottom'>Name</TableCell>
                <TableCell scope='col' border='bottom'>Temple</TableCell>
                <TableCell scope='col' border='bottom'>Country</TableCell>
                <TableCell scope='col' border='bottom'>M-Big</TableCell>
                <TableCell scope='col' border='bottom'>Big</TableCell>
                <TableCell scope='col' border='bottom'>Medium</TableCell>
                <TableCell scope='col' border='bottom'>Small</TableCell>
                <TableCell scope='col' border='bottom' align='right'>Score</TableCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {dashData.map((data, index) => {
                return(
                  <TableRow key={index}>
                    <TableCell style={{ paddingTop: '0.4em' }}>
                      <Anchor href={`/graph/${data.searchkey || 'hkcenter'}/${data.searchval}`} >
                        {data.searchval}
                      </Anchor>
                    </TableCell>
                    <TableCell style={{ paddingTop: '0.4em' }}>{data.temple}</TableCell>
                    <TableCell style={{ paddingTop: '0.4em' }}>{data.country}</TableCell>
                    <TableCell style={{ paddingTop: '0.4em' }}>{data['m-big'] || '-'}</TableCell>
                    <TableCell style={{ paddingTop: '0.4em' }}>{data.big || '-'}</TableCell>
                    <TableCell style={{ paddingTop: '0.4em' }}>{data.medium || '-'}</TableCell>
                    <TableCell style={{ paddingTop: '0.4em' }}>{data.small || '-'}</TableCell>
                    <TableCell style={{ paddingTop: '0.4em' }} align='right'>{parseFloat(data.score).toFixed(2) || '-'}</TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>}
        </Box>
      </CardBody>}

      <CardFooter pad='medium' background='light-2'>
        <Box flex direction='row' align='center' gap='medium' justify='between'>
          <Text></Text>
          <Button primary size='medium' href='/sankirtana' label='Add your score' />
        </Box>
      </CardFooter>
    </Card>

    {showdash && <GenericGraph firestore={firestore} fkey={'temple'} fvalue={'Hare Krishna Movement - Mumbai'} searchkey={'hkcenter'} />}
  </>)
}

export default CenterBoard